import { Box, Button, Modal, Paper, Typography } from "@mui/material";
import colors from "../theme/colors";

interface EndGameModalProps {
  open: boolean;
  undo: Function;
  endGame: Function;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: 400,
  bgcolor: colors.mediumGreen,
  boxShadow: 24,
  p: 4,
};

export default function EndGameModal({
  open,
  undo,
  endGame,
}: EndGameModalProps) {
  return (
    <Modal open={open}>
      <Paper elevation={6}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" align="center">
            Game Over?
          </Typography>
          <Box display={"flex"} justifyContent={"space-around"}>
            <Button
              variant="contained"
              style={{ backgroundColor: "#1B4F2D" }}
              onClick={() => endGame()}
            >
              End Leg
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#881918" }}
              onClick={() => undo()}
            >
              Undo
            </Button>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
}
